import { EXTERNAL_LOYALTY_PARTNERS } from "../../data/constants/shared";
import { defineProfile } from "./defaultProfile";

/**
 * Xeno — an ordinary points partner for redemption, and one of the **two** partners whose
 * enrolment consent is actually wired up on the backend. Legacy **class 1**.
 *
 * That single flag is the whole file. It publishes no programme, caps nothing, and needs no
 * special OTP length — everything else is the baseline.
 *
 * ⚠️ This file existed, was deleted on 2026-09-08 when its last two overrides (the coupon flags)
 * moved to `packages/core/discounts/providers`, and came back on 2026-09-18 with a real delta.
 * Its COUPON behaviour — the interesting part — is still declared there, not here.
 */
export const xenoProfile = defineProfile(EXTERNAL_LOYALTY_PARTNERS.XENO, {
  supportsEnrollmentConsent: true,
});
